// @ts-nocheck
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import style from "./OutputForm.module.scss";
import { OutputLabel } from "./OutputLabel";
import { MailOutputLabel } from "./MailOutputLabel";
import useLanguageChange from "../../../../hooks/useLanguageChange";

export const OutputForm = (props) => {
  const { t } = useLanguageChange(props.locale);
  const [labels, setLabels] = useState([]);
  const parsedOutputValue = props.output_value ? JSON.parse(props.output_value) : [];

  useEffect(() => {
    setLabels(parsedOutputValue);
  }, [props.output_value]);

  return (
    <div className={style.outputWrap}>
      <div className={style.outputContent}>
        {labels?.length !== 0 && (
          <div className={style.outputLabels}>
            {labels.map((label, index) => {
              return (
                <React.Fragment key={index}>
                  {props.template_class_name === "mail_trigger" ? (
                    <MailOutputLabel
                      label={label}
                      i={index}
                      iconPath={props.service_icon_name}
                      isDisplayNameEditable={props.is_display_name_editable}
                      isTestValueEditable={props.is_test_value_editable}
                      template_class_name={props.template_class_name}
                      direct_upload_url={props.direct_upload_url}
                    />
                  ) : (
                    <OutputLabel
                      label={label}
                      i={index}
                      key={index}
                      iconPath={props.service_icon_name}
                      isDisplayNameEditable={props.is_display_name_editable}
                      isTestValueEditable={props.is_test_value_editable}
                      template_class_name={props.template_class_name}
                      clientCode={props.clientCode}
                    />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

OutputForm.propTypes = {
  output_value: PropTypes.string,
  service_icon_name: PropTypes.string,
  template_class_name: PropTypes.string,
  is_display_name_editable: PropTypes.bool,
  is_test_value_editable: PropTypes.bool,
  direct_upload_url: PropTypes.string,
  clientCode: PropTypes.string,
  locale: PropTypes.string,
};
